/**
 * 协商文件
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/8/31      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react';
import PropTypes from "prop-types";
import "./FileList.less";
import {getFileSuffix} from '@utils/utils';
import { loadImage } from "@utils/image-func";
class FileList extends React.Component{
    constructor(props) {
        super(props);
    }

    getImg(item){
        let content = '';
        let {type,fileUrl,fileName} = this.props;
        const extend = getFileSuffix(item[fileUrl]); //item[type];
        if(['jpg','jpeg','gif','png','bmp'].indexOf(extend)!=-1){
            content = <img src={item[fileUrl]} className="file-list__img" alt={item[fileName]}/>;
        }else if(['xls','xlsx'].indexOf(extend)!=-1){
            content = <img src="http://oss.essa.cn/c7804cba-b869-4eb4-98b6-e40b27b17c7a.png" className="img-icon" alt={item[fileName]}/>;
        }else if(['pdf'].indexOf(extend)!=-1){
            content = <img src="http://oss.essa.cn/25d804fd-934f-48ad-87bb-b60cb16aabe1.png" className="img-icon" alt={item[fileName]}/>;
        }else if(['doc','docx'].indexOf(extend)!=-1){
            content = <img src="http://oss.essa.cn/ab46c1fc-e250-4f44-b4fd-386189c09709.png" className="img-icon" alt={item[fileName]}/>;
        }else if(['mp4','flv'].indexOf(extend)!=-1){
            content = <img src="http://oss.essa.cn/2792c0d8-aee8-4047-b2c1-ffbd19bc8064.png" className="img-icon" alt={item[fileName]}/>;
        }else if(['zip','rar','7z'].indexOf(extend)!=-1){
            content = <img src="http://oss.essa.cn/8bdbac2f-9e07-4714-8a55-27f0fe4cd235.jpg" className="img-icon" alt={item[fileName]}/>;
        }
        return content;
    }

    /**
     * 打开视频播放器
     */
    openVideo(item){
        window.open(item[this.props.fileUrl]);
    }

    /**
     * 放大图片
     */
    openImg(item){
        window.open(item[this.props.fileUrl]);
    }

    /**
     * 打开文件
     **/
    openDocument(item){
        $.ajax({
            url: `/service/dubbo/proxy/file/preview-file`,
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify({
                id:item[this.props.fileId]
            }),
            success:(res)=>{
                if(res.success&&res.valid){
                    window.open(res.model);
                }
            }
        });
    }

    openShow(item){
        // let extend = item[this.props.type];
        const extend = getFileSuffix(item[this.props.fileUrl]);
        if(['jpg','jpeg','gif','png','bmp'].indexOf(extend)!=-1){
            this.openImg(item);
        }else if(['xls','xlsx','pdf','doc','docx'].indexOf(extend)!=-1){
            this.openDocument(item);
        }else if(['mp4','flv'].indexOf(extend)!=-1){
            this.openVideo(item);
        }else if(['zip','rar','7z'].indexOf(extend)!=-1){
            this.openImg(item);
        }
    }

    delete(index,e){
        e.stopPropagation();
        e.preventDefault();
        let imgList = [].concat(this.props.list);
        imgList.splice(index,1);
        this.props.onChange(imgList);
    }

    render(){
        const {list,fileName,fileId,fileUrl,type} = this.props;
        return (
            <ul className="file-list__wrap">
                {
                    list.map((item,index)=>{
                        return <li key={index}>
                            <div className="file-list__img-wrap" onClick={this.openShow.bind(this,item)}>
                                {this.getImg(item)}
                            </div>
                            {/*<div className="file-list__text" title={item[fileName]}>{item[fileName]}</div>*/}
                            {
                                this.props.canDelete?
                                    <div className="file-mask" onClick={this.delete.bind(this,index)}>
                                        <i className="ri-delete-bin-line"></i>
                                    </div>
                                    :
                                    null
                            }
                        </li>
                    })
                }
            </ul>
        )
    }
}

FileList.defaultProps = {
    list:[],
    fileName:'fileName',
    fileId:'fileId',
    fileUrl:'fileUrl',
    canDelete:false,
    onChange:function () {

    }
}

FileList.propTypes = {

}
export default FileList;
